import {useDropzone} from "react-dropzone";
import {toast} from "react-toastify";
import useDidMountEffect from "../../utils/custom-hook/use-did-mount-effect";
import {isImageFile} from "../../utils/image/is-image-file";
import {OutlinedBlackButton} from "../button/OutlinedBlackButton";

interface Props {
    setFiles: (files: File[]) => void;
}

export const LocationImageDropZoneButton: React.FC<Props> = (
    {
        setFiles,
    }
) => {
    const {getRootProps, open, acceptedFiles} = useDropzone();

    useDidMountEffect(() => {
        for (const [index, file] of acceptedFiles.entries()) {
            if (!isImageFile(file.type)) {
                toast.error("이미지 파일만 업로드 가능합니다.");
                return;
            }
            if (acceptedFiles.length - 1 === index) {
                setFiles(acceptedFiles);
            }
        }
    }, [acceptedFiles]);

    return (
        <div {...getRootProps({className: "dropzone"})}>
            <OutlinedBlackButton
                width="10.625rem"
                height="3.188rem"
                text="파일 불러오기"
                onClick={open}
            />
        </div>
    );
};
